<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/xDogS9/tc-custom/9781467458887.jpg?1709697148712" alt="This image is the cover for the book Letters from Bear"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Letters from Bear
      </h1>
      <p class="bookDescription body article font2">
        <p>Bear can’t imagine a whole winter without her friend, so when Bird migrates south, Bear decides to follow. She’s never left the forest before, but that won’t stop her from crossing oceans and mountains—and sending letters along the way. But a surprise is waiting for Bear on the beach… </p><p>Richly told in amusing letters and lush illustrations, this adventurous story invites readers to consider just how far they’d go for their friends.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Gauthier David, Marie Caudry
      </h2>
      
      <p class="authorDescription body article"><BR /><B>Gauthier David</B>&#160;is a children&#39;s author, illustrator, and singer-songwriter. He has collaborated on several books with his partner Marie Caudry.&#160;<I>Letters from Bear</I>&#160;is their English-language debut. Gauthier and Marie live with their children in the Dr&ocirc;me, France, at the edge of a forest where they can sometimes see wolves. Visit his website at&#160;<a href="http://gogocosmos.free.fr/">gogocosmos.free.fr</a>.<BR /><BR /><B>Marie Caudry</B>&#160;is a graduate of the Fine Arts School of Bordeaux and has illustrated a number of books. Three days before the birth of their child Arto, Marie began a series of paintings about globe-trotting bears-and these paintings inspired Gauthier to write the story of&#160;<I>Letters from Bear</I>. Visit Marie&#39;s website at&#160;<a href="http://mariecaudry.free.fr/">mariecaudry.free.fr</a>&#160;or follow her on Instagram @mariecaudry.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Wm. B. Eerdmans Publishing Co.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?419221a8